export const SET_SLIDEOUT_DATA = 'SET_SLIDEOUT_DATA';
export const SET_ACTIVE_SLIDER = 'SET_ACTIVE_SLIDER';

export const setSlideoutData = (activeSlider, dueTasks) => ({
    type: SET_SLIDEOUT_DATA,
    payload: { activeSlider, dueTasks }
});
export const setActiveSlider = (activeSlider) => ({
    type: SET_ACTIVE_SLIDER,
    payload: { activeSlider }
});